import React, { FC, useEffect, useRef } from 'react';

export interface SliderProps {
    min: number;
    max: number;
    step: number;
    rente: number;
    onChangeRente: (rente: number) => void;
}

const Slider: FC<SliderProps> = ({ min, max, step, rente, onChangeRente }) => {
    const thumRef = useRef<HTMLDivElement>(null);
    const trackRef = useRef<HTMLDivElement>(null);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const pos = (parseFloat(event.target.value) / max) * 100;
        if (!!thumRef.current && !!trackRef.current) {
            thumRef.current.style.left = `${pos - 5}%`;
            trackRef.current.style.width = `${pos}%`;
        }
        onChangeRente(parseFloat(event.target.value));
    };

    useEffect(() => {
        const pos = (rente / max) * 100;
        if (!!thumRef.current && !!trackRef.current) {
            thumRef.current.style.left = `${pos - 5}%`;
            trackRef.current.style.width = `${pos}%`;
        }
    }, [rente, max]);

    return (
        <div className="slider-wrap margin-bottom-larger">
            <input type="range" className="range" min={min} max={max} step={step} onChange={handleChange} />
            <div className="track">
                <div ref={trackRef} className="track-inner" />
            </div>
            <div ref={thumRef} className="thumb">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 6.99994H8.38L9.71 5.70994C9.80324 5.6167 9.8772 5.50601 9.92766 5.38419C9.97812 5.26237 10.0041 5.1318 10.0041 4.99994C10.0041 4.86808 9.97812 4.73751 9.92766 4.61569C9.8772 4.49387 9.80324 4.38318 9.71 4.28994C9.61676 4.1967 9.50607 4.12274 9.38425 4.07228C9.26243 4.02182 9.13186 3.99585 9 3.99585C8.86814 3.99585 8.73757 4.02182 8.61575 4.07228C8.49393 4.12274 8.38324 4.1967 8.29 4.28994L5.29 7.28994C5.19627 7.3829 5.12188 7.49351 5.07111 7.61536C5.02034 7.73722 4.9942 7.86793 4.9942 7.99994C4.9942 8.13195 5.02034 8.26266 5.07111 8.38452C5.12188 8.50638 5.19627 8.61698 5.29 8.70994L8.29 11.7099C8.38296 11.8037 8.49356 11.8781 8.61542 11.9288C8.73728 11.9796 8.86799 12.0057 9 12.0057C9.13201 12.0057 9.26272 11.9796 9.38458 11.9288C9.50644 11.8781 9.61704 11.8037 9.71 11.7099C9.80373 11.617 9.87812 11.5064 9.92889 11.3845C9.97966 11.2627 10.0058 11.132 10.0058 10.9999C10.0058 10.8679 9.97966 10.7372 9.92889 10.6154C9.87812 10.4935 9.80373 10.3829 9.71 10.2899L8.45 8.99994H19C19.2652 8.99994 19.5196 8.89458 19.7071 8.70705C19.8946 8.51951 20 8.26516 20 7.99994C20 7.73472 19.8946 7.48037 19.7071 7.29283C19.5196 7.1053 19.2652 6.99994 19 6.99994Z" />
                    <path d="M18.92 15.6199C18.8724 15.4972 18.801 15.385 18.71 15.2899L15.71 12.2899C15.5217 12.1016 15.2663 11.9958 15 11.9958C14.7337 11.9958 14.4783 12.1016 14.29 12.2899C14.1017 12.4782 13.9959 12.7336 13.9959 12.9999C13.9959 13.2662 14.1017 13.5216 14.29 13.7099L15.59 14.9999H5C4.73478 14.9999 4.48043 15.1053 4.29289 15.2928C4.10536 15.4804 4 15.7347 4 15.9999C4 16.2652 4.10536 16.5195 4.29289 16.707C4.48043 16.8946 4.73478 16.9999 5 16.9999H15.59L14.29 18.2899C14.1963 18.3829 14.1219 18.4935 14.0711 18.6154C14.0203 18.7372 13.9942 18.8679 13.9942 18.9999C13.9942 19.132 14.0203 19.2627 14.0711 19.3845C14.1219 19.5064 14.1963 19.617 14.29 19.7099C14.383 19.8037 14.4936 19.8781 14.6154 19.9288C14.7373 19.9796 14.868 20.0057 15 20.0057C15.132 20.0057 15.2627 19.9796 15.3846 19.9288C15.5064 19.8781 15.617 19.8037 15.71 19.7099L18.71 16.7099C18.801 16.6148 18.8724 16.5027 18.92 16.3799C19.02 16.1365 19.02 15.8634 18.92 15.6199Z" />
                </svg>
            </div>
        </div>
    );
};

export default Slider;
